import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Personnage } from '../_models/personnage';
import { environment } from '../../environments/environment';
import { CreatePersonnageCommand, DeletePersonnageCommand, UpdateBackgroundCommand, UpdateJoueurCommand } from '../_models/_commands/createPersonnageCommand';
import { Observable } from 'rxjs';
import { CommandResult } from '../_models/commandResult';
import { AddCompetenceCommand, AddNiveauCompetenceCommand, RemoveCompetenceCommand, RemoveNiveauCompetenceCommand } from '../_models/_commands/competenceCommands';
import { AddAchatSortCommand, RemoveAchatSortCommand, AddSortCommand, RemoveSortCommand } from '../_models/_commands/sortCommands';
import { Joueur } from '../_models/joueur';

@Injectable({
  providedIn: 'root'
})
export class CharacterSheetService {

  constructor(private http: HttpClient) { }

  createCharacter(personnage: Personnage) {
      return this.http.post(`${environment.apiUrl}/users/register`, personnage);
  }

  getPersonnage(id: number) {
    var params = new HttpParams({fromString: `id=${id}`});
    return this.http.get<Personnage>(`${environment.apiUrl}/api/PersonnageFunctions_Get`, {params: params});
  }

  getJoueur() {
    return this.http.get<Joueur>(`${environment.apiUrl}/api/JoueurFunctions_Get`);
  }

  updateJoueur(command: UpdateJoueurCommand) {
      return this.http.post<CommandResult>(`${environment.apiUrl}/api/JoueurFunctions_Update`, command);
  }

  deletePersonnage(command: DeletePersonnageCommand) {
      return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_Delete`, command);
  }

  listPersonnages() :Observable<Personnage[]> {
    return this.http.get<Personnage[]>(`${environment.apiUrl}/api/PersonnageFunctions_List`);
  }

  createPersonnage(command: CreatePersonnageCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_Create`, command);
  }

  updateBackground(command: UpdateBackgroundCommand) {
      return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_UpdateBackground`, command);
  }

  addAchatSort(command: AddAchatSortCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_AddAchatSort`, command);
  }

  removeAchatSort(command: RemoveAchatSortCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_RemoveAchatSort`, command);
  }

  addCompetence(command: AddCompetenceCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_AddCompetence`, command);
  }

  removeCompetence(command: RemoveCompetenceCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_RemoveCompetence`, command);
  }

  addNiveauCompetence(command: AddNiveauCompetenceCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_AddNiveauCompetence`, command);
  }

  removeNiveauCompetence(command: RemoveNiveauCompetenceCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_RemoveNiveauCompetence`, command);
  }

  addSort(command: AddSortCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_AddSort`, command);
  }

  removeSort(command: RemoveSortCommand) {
    return this.http.post<CommandResult>(`${environment.apiUrl}/api/PersonnageFunctions_RemoveSort`, command);
  }
}
